import { memo } from "react";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import {
    OnboardingApplicationStep,
    OnboardingApplication,
    ECommerceOnboardingApplication,
    onboardingApplicationStepAndFieldStatus
} from "consts/onboarding";
import {
    StepLabel,
    useApplicationDetailContext,
    type StepLabelProps
} from "ui/organizms/Onboarding/Applications/common";

const PaymentMethodsLabel = (props: Partial<StepLabelProps>) => {
    const { getStepData } = useApplicationDetailContext();

    const data = getStepData(ECommerceOnboardingApplication.PaymentMethods);

    return (
        <StepLabel
            to={`${OnboardingApplicationStep[OnboardingApplication.ECommerce].PaymentMethods}`}
            Icon={CreditScoreIcon}
            {...onboardingApplicationStepAndFieldStatus.get(data.status)}
            {...props}
        >
            Payment Methods
        </StepLabel>
    );
};

export default memo(PaymentMethodsLabel);
